module.exports = __webpack_public_path__ + "img/35.6740d2d8.jpg";